import React, { useRef, useEffect } from 'react'
import { useVideoPlayer } from './Provider'

interface VideoPlayerProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
  src: string
  poster?: string
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  src,
  poster,
  className,
  ...props
}) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const { playingVideo, setPlayingVideo } = useVideoPlayer()

  useEffect(() => {
    if (
      videoRef.current &&
      playingVideo !== videoRef.current &&
      !videoRef.current.paused
    ) {
      videoRef.current.pause()
    }
  }, [playingVideo])

  const handlePlay = () => {
    if (videoRef.current) {
      setPlayingVideo(videoRef.current)
    }
  }

  const fixedClassName =
    className?.replace(/aspec-w-9 aspec-h-16/g, 'aspect-w-16 aspect-h-9') || ''

  const videoProps = {
    ref: videoRef,
    onPlay: handlePlay,
    src: src,
    className: fixedClassName,
    ...props,
  } as any

  if (poster) {
    videoProps.poster = poster
    videoProps.preload = 'none'
  } else {
    // When no poster is provided, ensure metadata is loaded to display the first frame
    videoProps.preload = 'metadata'
  }

  return <video {...videoProps}></video>
}
